// columninfo / panel からキー項目・項目名・パネル type を引く小さな共通ヘルパ。
export function createColumnInfoService(deps) {
    const {
        isEmpty,
        getColumnInfo,
        getPanels
    } = deps;

    // 主キー項目の columnid を返す。
    function primarykey() {
        const columninfo = getColumnInfo();
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }

    //項目名取得
    function nametocolumn(name) {
        const columninfo = getColumnInfo();
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }

    // パネルIDから s_layout の type を引く。
    function tabletype(id) {
        const panel = getPanels();
        let pnl = isEmpty(panel) ? null : panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    return { primarykey, nametocolumn, tabletype };
}
